/**
 * created by li si yi
 * 工作桌面-待我处理
 */
import React, {Component} from 'react';
import {Button, Empty, Icon, Modal, Select} from "antd";
import PropTypes from "prop-types";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import MyIconSvg from "../../../sysManagement/messageCenter/svg";
import BaseComponent from "../../../../base/BaseComponent";
import {getInfoFromLocalStorage,setInfoToLocalStorage} from "../../../../actions";
import ProcessToDo from '../config/ProcessToDo'
import {HEADER_HEIGHT} from "../../../../constants";

const {Option} = Select;

export default class WorkDesktopUntreated extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            num: 0,
            dataSource: [],// 表格数据
            treeData: [], // 下拉框选项
            selected: '', // 下拉框当前选中
            activitiCategoryKey: '',// 当前选中类型
            params: {
                activitiCategoryKeys: [],
                operatorUser: '',// 当前用户
                showData: true,
                pagingFlag: false,
            },
            otherDeptData: [],
            otherDeptAllNum: 0,
            showFlag:true
        };
    }

    componentWillMount() {
        let account = getInfoFromLocalStorage("currentUser").id;
        this.state.params.operatorUser = account;
		this.getMediaList();
        this.getTree();
    }

    componentDidMount() {
        this.getOtherData()
    }

    componentWillUnmount() {
    }
	getMediaList = () =>{
            this.getCurrentMediaList().then((res) => {
                let mediaList=[];
                if (res && res.length) {
                    mediaList=res
                }
                console.log('currentMediaList',mediaList);
                setInfoToLocalStorage("currentMediaList", mediaList);
            });
    };

    // 获取待办树分类数据
    getTree = () => {
        this.request({
            url: '/cm-sites-sys/activitiCategory/getTree',
            contentType: "json",
            callBack: (res) => {
                // console.log(res);
                let treeData = [];
                if (res) {
                    treeData = res.sons;
                }
                this.setState({treeData});
                this.getData();
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 获取表数据
    getData = () => {
        let {params, selected} = this.state;
        this.state.activitiCategoryKey = selected;
        this.request({
            url: "/cm-sites-sys/process/getTodoList",
            method: "post",
            body: params,
            contentType: "json",
            callBack: (res) => {
                let dataSource = [];
                let num = 0;
                if (res) {
                    dataSource = res.data;
                    num = res.count;
                }
                this.setState({dataSource, num})
            },
            errorCallBack: (e) => {
            }
        })
    };

    // 获取其他部门待办数量
    getOtherData = () => {
        let getUserInfo = getInfoFromLocalStorage('currentUser');
        let userId = getUserInfo.id;
        let defaultInfo = getUserInfo.defaultInfo;
        let infoList = getUserInfo.infoList;
        if (infoList && infoList.length <= 1) {
            this.setState({
                showFlag: false
            })
        }
        let params = {
            userId: userId
        };
        this.request({
            url: "/cm-sites-sys/process/getDeptsCount",
            body: params,
            callBack: (res) => {
                // console.log('666666666666666', res);
                let otherDeptDataAll = [];
                let otherDeptData = [];
                let otherDeptAllNum = 0;
                if (res) {
                    otherDeptDataAll = res;
                    otherDeptDataAll && otherDeptDataAll.forEach(item => {
                        if (!(defaultInfo.dept.id === item.deptId)) {
                            otherDeptAllNum += item.count;
                            otherDeptData.push(item);
                        }
                    });
                }
                this.setState({otherDeptData, otherDeptAllNum})
            },
            errorCallBack: (e) => {
            }
        })
    };

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 30 - 300 - 20;
        return (
            <div style={{
                // width: '1088px',
                height: 517,
                background: '#fff',
                borderRadius: '5px',
                paddingBottom: "24px"
            }}>
                {/*待我处理头部*/}
                {this.renderTitle()}
                {/*内容*/}
                {this.renderTable()}
                <ProcessToDo ref={(ProcessToDo) => {
                    this.ProcessToDo = ProcessToDo
                }} refresh={() => {
                    this.getData()
                }}/>
                {/*切换部门弹窗*/}
                {this.renderChangeDeptModal()}
            </div>
        )
    }

    // title部分
    renderTitle = () => {
        let {num, treeData, otherDeptAllNum, showFlag} = this.state;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '10px',
                borderBottom: '1px solid #ccc',
                alignItems: 'center',
            }}>
                <div style={{display: 'flex', alignItems: 'center',}}>
                    <span
                        style={{color: '#000', fontSize: '16px', padding: '6px 0 6px 14px'}}>待我处理（{num}）
                    </span>
                    {
                        showFlag && otherDeptAllNum!==0 ? <span style={{fontSize: '12px', cursor: 'pointer'}} onClick={() => {
                            this.onShowModal()
                        }}>您其他部门有{otherDeptAllNum}条待办，请切换部门查看</span> : null
                    }
                </div>
                
            </div>
        )
    };

    // 切换部门弹窗
    renderChangeDeptModal() {
        let {otherDeptData} = this.state;
        return (
            <Modal
                title={'其他部门待办数'}
                visible={this.state.isShowChangeDept}
                maskClosable={true}
                onCancel={() => {
                    this.setState({
                        isShowChangeDept: false,
                    })
                }}
                onOk={() => {
                    this.setState({
                        isShowChangeDept: false,
                    })
                }}
                footer={null}
                centered={true}
                width={400}
            >
                <Scrollbars autoHide style={{height: 90}}>
                    {
                        otherDeptData ? otherDeptData.map((item, index) => {
                                return (
                                    <div style={{display: 'flex', justifyContent: 'space-between', margin: '6px 0', padding: '0 10px'}}
                                         key={index}>
                                        <span style={{
                                            width: '50%',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis'
                                        }}>{item.deptName}</span>
                                        <span>{item.count} 条</span>
                                    </div>
                                )
                            })
                            : null
                    }
                </Scrollbars>
            </Modal>
        )
    }

    //数据回显
    onShowModal = () => {
        this.setState({
            isShowChangeDept: true,
        })
    };

    renderDataTitle = item => {
        switch (item?.activitiCategoryKey) {
            case 'zyxzsq':
                return item?.data?.applyReason || item?.title || ''
            case 'positionAudit':
                return item?.data?.name || item?.title || ''
            case 'weibo':
                return item?.data?.text || item?.title || ''
            default:
                return item?.title || ''
        }
    }

    // 内容部分
    renderTable = () => {
        let {dataSource} = this.state;
        return (
            <div style={{display: 'flex', justifyContent: 'center', height: '90%'}}>
                {dataSource && dataSource.length ?
                    <Scrollbars autoHide>
                        <ul style={{padding: '0px 24px', listStyle: 'none'}}>
                            {
                                dataSource.map(item => {
                                    let icon = this.itemTodoIcon(item) || "toDoListDefault";
                                    // let picIcon;
                                    // switch (item.activitiCategoryKey) {
                                    //     case 'ziyuan':
                                    //         picIcon = "IconResource";
                                    //         break;
                                    //     case 'xiansuo':
                                    //         picIcon = "PicClues";
                                    //         break;
                                    //     case 'xuanti':
                                    //         picIcon = "IconTopic";
                                    //         break;
                                    //     case 'yuegao':
                                    //         picIcon = "Approximations";
                                    //         break;
                                    //     case 'caifang':
                                    //         picIcon = "IconInterview";
                                    //         break;
                                    //     case 'tongzhi':
                                    //         picIcon = "IconManuscript";
                                        //     break;
                                        // case 'webNews':
                                        //     picIcon = "WebsiteIcon";
                                        //     break;
                                        // case 'story':
                                        //     picIcon = "ContributeIcon";
                                        //     break;
                                        // case 'likeWechat':
                                    //         picIcon = "ContributeIcon";
                                    //         break;
                                    //     case 'storyToWebNews':
                                    //         picIcon = "ContributeIcon";
                                    //         break;
                                    //     case 'tggj':
                                    //         picIcon = "ContributeIcon";
                                    //         break;
                                    //     case 'likewebsite':
                                    //         picIcon = "ContributeIcon";
                                    //         break;
                                    //     case 'weibo':
                                    //         picIcon = "MicroblogIcon";
                                    //         break;
                                    //     case 'zyxzsq':
                                    //         picIcon = "DownloadResourcesIcon";
                                    //         break;
                                    //     case 'material':
                                    //         picIcon = "OfficialIcon";
                                    //         break;
                                    //     case 'busNewsClue':// 线索
                                    //         picIcon = "BusNewsClueIcon";
                                    //         break;
                                    //     case 'mediaAudit':
                                    //         picIcon = "MediaIcon";
                                    //         break;
                                    //     case 'busTopicSelection':// 选题
                                    //         picIcon = "XuantiIcon";
                                    //         break;
                                    //     case 'rwgj':// 采访稿件
                                    //         picIcon = "CFManuscript";
                                    //         break;
                                    //     case 'yggj':// 约稿稿件
                                    //         picIcon = "YGManuscript";
                                    //         break;
                                    //     default:
                                    //         picIcon = "toDoListDefault";
                                    //         break;
                                    // }
                                    let time = moment(item.updateTime).startOf('mm').fromNow();
                                    return (
                                        <li style={{borderBottom: "1px solid #ccc", padding: '17px 0',cursor:'pointer'}} key={item.id}
                                            onClick={() => {
                                                console.log(item);
                                                this.itemTodoClick(item);
                                            }}>
                                            <div style={{display: 'flex'}}>
                                                <div style={{alignSelf: 'center', width: '5%', marginRight: '20px'}}>
                                                    <MyIconSvg type={icon} style={{size: 50, alignSelf: 'center'}}
                                                               colors={["rgb(220, 244, 236)", "rgb(40, 174, 126)"]}/>
                                                </div>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    width: '93%',
                                                    lineHeight: '23px',
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-between',
                                                        width: '80%',
                                                    }}>
                                                        <div style={{display:'flex'}}>
                                                            <div style={{
                                                                color: '#000',
                                                                cursor: 'pointer',
                                                                marginRight: '12px',
                                                                fontWeight: 'bold',
                                                            }}>{item.activitiCategoryName}</div>
                                                            <div style={{}}>{time === "几秒前" ? "刚刚" : time}</div>
                                                        </div>
                                                        <div
                                                            title={this.renderDataTitle(item)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis',
                                                            }}>{this.renderDataTitle(item)}</div>
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-between',
                                                        width: '20%',
                                                        alignItems: 'flex-end',
                                                    }}>
                                                        {item.taskName ? <div title={item.taskName} style={{
                                                            textAlign: 'end',
                                                            width: 150,
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis'
                                                        }}>{item.taskName}</div> : ""}
                                                        <div
                                                            style={{
                                                                alignSelf: 'flex-end',
                                                                width: 85,
                                                                textAlign: 'end',
                                                            }}
                                                            title={item.operatorUserName ? item.operatorUserName : ''}>
                                                            <div style={{
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis'
                                                            }}>{item.operatorUserName ? item.operatorUserName : ''}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </Scrollbars> : <Empty style={{alignSelf: 'center'}}/>}
            </div>
        )
    };
    // 下拉框改变
    handleChange = (value, option) => {
        console.log("value,option", value, option.key);
        this.state.selected = option.key;
        // this.state.params.activitiCategoryKey = option.key;
        // 微信、公众号、微博、网站稿件迁移到稿件里
        if (option.key === 'story') {
            this.state.params.activitiCategoryKeys = ['webNews', 'weibo', 'material', 'story']
        } else if (!option.key) {
            this.state.params.activitiCategoryKeys = []
        } else {
            this.state.params.activitiCategoryKeys = [option.key];
        }
        this.getData();
    };
    // 点击执行当前方法
    itemTodoClick(item) {
        this.ProcessToDo.getTodoList(item);
    }
    // 点击执行当前方法
    itemTodoIcon(item) {
        let icon = this.ProcessToDo.getTodoListIcon(item);
        return icon
    }
};

WorkDesktopUntreated.defaultProps = {};
WorkDesktopUntreated.propTypes = {};